<template>
	<div class="body">
		<div class="industry-ctr" v-if="list">

			<div class="cnt-nav-ctr">
				<div class="cnt-nav-inner">
					<div class="cnt-nav-item" v-for="(item, index) in navList" :key="index" @click="clickRoute(item)">

						<img :src="item.icon" class="nav-item-icon" />
						<label
							:class="['nav-item-name', index == navList.length - 1 ? 'nav-item-name-selected' : '']">{{ item.name }}</label>

						<img src="http://syzsoss.oss-cn-chengdu.aliyuncs.com/202509/13144709-98064606215907526.png"
							class="nav-arrow" v-if="index != navList.length - 1" />
					</div>
				</div>
			</div>

			<div class="content-title">
				<img class="title-wing" src="@/assets/icons/title_wing_left.png" />
				<span class="title-text">{{ title }}</span>
				<img class="title-wing" src="@/assets/icons/title_wing_right.png" />
			</div>
			
			<div class="tab-ctr">
				<div class="tab-inner">
					<div :class="['tab-item', tabIndex == index ? 'tab-item-s' : '']" v-for="(item, index) in tabList" :key="index" @click="clickTab(index)">{{item.name}}</div>
				</div>
			</div>
			

			<div class="major-filter-ctr">
				<el-form :inline="true">
					<el-form-item label="专业">
						<el-select v-model="targetMajor" placeholder="请输入关键字" class="select-width" :clearable=true reserve-keyword
							@change="changeMajor">
							<el-option v-for="item in majorList" :key="item.code" :label="item.name"
								:value="item.code">
							</el-option>
						</el-select>
					</el-form-item>
				</el-form>
				
				<div>
					<el-button type="primary" icon="el-icon-edit" size="medium" @click="clickEditGroupMajor()">编辑专业</el-button>
				</div>

			</div>

			<div class="table-ctr" v-if="tabList[tabIndex]['type'] == 'career' ">
				<el-table :data="list" :span-method="spanMethod" border>
		
					<el-table-column label="专业名称" align="center" prop="major_name"  min-width="1"/>
					<el-table-column label="岗位名称" align="center" prop="career_name"  min-width="1"/>
					<el-table-column label="岗位对应证书" align="center" prop="certs"  min-width="1"/>
					<el-table-column label="岗位介绍" align="center" prop="task"  min-width="3"/>
				</el-table>
				
				<div class="pagination">
					<pagination v-show="queryParams.total>0" :total="queryParams.total" :page.sync="queryParams.page"
						:limit.sync="queryParams.pageSize" @pagination="loadMoreMajorData" />
				</div>
			</div>
		</div>
		
		<div class="fix-action-ctr" v-if="createData">
			<el-button v-if="createData.exist != 1" type="danger" icon="el-icon-message" size="large" @click="clickSaveMajor()">{{createData.name}}</el-button>
			<el-button v-else type="danger" icon="el-icon-check" size="large" @click="clickSaveMajor()">{{createData.name}}</el-button>
		</div>
		
		<el-dialog title="编辑专业" :visible.sync="showGroupMajorDialog" append-to-body v-if="showGroupMajorDialog"
			align="center" @close="onGroupDialogClosed">
			
			<div class="dialog-tab-ctr">
				<label v-for="(item,index) in groupAddList" :class="['dialog-tab-item', index == groupAddIndex ? 'dialog-tab-item-s' : '']" :key="index" @click="clickAddTab(index)">{{item.name}}</label>
			</div>

			<el-form :inline="true" align="left">
				<el-form-item label="专业大类">
					<el-select v-model="topMajor" placeholder="请输入关键字" class="select-group-width" filterable remote
						:clearable=true reserve-keyword :remote-method="loadGroupTopMajorList"
						@change="changeGroupTopMjor">
						<el-option v-for="item in dialogTopMajorList" :key="item.code" :label="item.name" :value="item.code">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="专业类">
					<el-select v-model="parentMajor" placeholder="请输入关键字" class="select-group-width" :clearable=true
						filterable remote reserve-keyword :remote-method="loadGroupParentMajorList"
						@change="changeGroupParentMajor">
						<el-option v-for="item in dialogParentMajorList" :key="item.code" :label="item.name"
							:value="item.code">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="专业">
					<el-select v-model="major" placeholder="请输入关键字" class="select-group-width" :clearable=true
						filterable remote reserve-keyword :remote-method="loadGroupMajorList"
						@change="changeGroupMajor">
						<el-option v-for="item in dialogMajorList" :key="item.code" :label="item.name" :value="item.code">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>

			<div class="data-table">
				<el-table :data="groupDataList" border>
					<el-table-column prop="name" label="专业" align="center"></el-table-column>
					<el-table-column prop="topMajor" label="专业大类" align="center"></el-table-column>
					<el-table-column prop="parentMajor" label="专业类" align="center"></el-table-column>
					<el-table-column label="操作" align="center">
						<template v-slot="{ row }">
							<el-button type="primary" size="small" @click="clickAddGroupMajor(row.code)"
								v-if="row.isAdd != 1">添加</el-button>
							<el-button type="warning" size="small" @click="clickRemoveGroupMajor(row.code)"
								v-else>移除</el-button>
						</template>
					</el-table-column>

				</el-table>

				<div class="pagination">
					<pagination v-show="groupQueryParams.total>0" :total="groupQueryParams.total" :page.sync="groupQueryParams.page"
						:limit.sync="groupQueryParams.pageSize" @pagination="queryGroupMajorData" />
				</div>
			</div>
			<div slot="footer" class="dialog-footer" align="center">
				<el-button type="primary" @click="clickCloseGroupDialog()">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getGroupMajorCareerData,
		getTargetMajorList,
		getGroupTopMajorList,
		getGroupParentMajorList,
		getGroupMajorList,
		getGroupEditMajorList,
		confirmCreateMajorGroup
	} from "@/api/matrix"

	import {
		getSpanMap,
		isEmpty
	} from "@/utils/util"

	import {
		Notification,
		Message,
		Loading
	} from 'element-ui'

	import {
		parse,
		handleProtocal,
		handleRouteProtocal
	} from "@/utils/protocal"

	export default {
		name: "Famous",
		data() {
			return {
				title: '',
				majorSpanMap: {},
				showGroupMajorDialog: false,
				navList: null,
				groupAddList: [{
						'name': '未添加',
						'value': 2
					},
					{
						'name': '已添加',
						'value': 1
					},
				],
				tabList: [{
						'name': '职业分析',
						'type': 'career'
					},{
						'name': '企业分析',
						'type': 'company'
					},{
						'name': '人才供应分析',
						'type': 'supply'
					}
				],
				queryParams: {
					page: 1,
					pageSize: 20,
					total: 0
				},
				tabIndex: 0,
				groupAddIndex: 0,
				topIndustry: '',
				topIndustryList: [],
				groupQueryParams: {
					page: 1,
					pageSize: 10,
					total: 0,
				},
				groupDataList: [],
				list: null,
				majorList: [],
				targetMajor: '',
				dialogTopMajorList: [],
				dialogParentMajorList: [],
				dialogMajorList: [],
				topMajor: '',
				parentMajor: '',
				major: '',
				createData: null
			}
		},
		created() {
			this.requestData();
		},
		methods: {
			requestData() {
				this.groupId = this.$route.query.id;
				this.codes = this.$route.query.codes;				
				this.loadMajorInfoData(this.codes)
				this.loadTargetMajorList();
			},
			
			loadMoreMajorData(){
				let codes = this.targetMajor
				
				if(isEmpty(codes)){
					codes = this.codes;
				}
				
				this.loadMajorInfoData(codes, true)
			},
			
			loadMajorInfoData(codes, fromFilter=false){
				this.queryParams.group_id = this.groupId;
				this.queryParams.codes = codes;
				getGroupMajorCareerData(this.queryParams).then(res => {
					let realData = res.data;
					this.title = realData.title;
					this.list = realData.list;
					this.queryParams.total = realData.pageData.totalCount;
					this.createData = realData.createData;
					if(!fromFilter){
						this.codes = realData.codes;
					}
				
					this.majorSpanMap = getSpanMap(this.list, ['major_name'])
					this.initNavData();
				});
			},
			
			initNavData(){
				if(this.createData.exist == 1){
					this.navList = [{
							'icon': 'http://syzsoss.oss-cn-chengdu.aliyuncs.com/202509/13152635-89000603806795123.png',
							'name': '专业群分析',
							'url': 'replace://matrix?activeLeftTab=5'
						},
						{
							'icon': 'http://syzsoss.oss-cn-chengdu.aliyuncs.com/202509/13153102-77494491196988002.png',
							'name': '专业分析',
							'url': ''
						}
					]
				}else{
					this.navList = [{
							'icon': 'http://syzsoss.oss-cn-chengdu.aliyuncs.com/202509/13152635-89000603806795123.png',
							'name': '专业群分析',
							'url': 'replace://matrix?activeLeftTab=5'
						},
						{
							'icon': 'http://syzsoss.oss-cn-chengdu.aliyuncs.com/202510/28192136-14435612870031685.png',
							'name': '共性行业',
							'url': 'replace://sameIndustry?id=' + this.groupId
						},
						{
							'icon': 'http://syzsoss.oss-cn-chengdu.aliyuncs.com/202510/28191917-35795125031313969.png',
							'name': '专业分析',
							'url': ''
						}
					]
				}
			},
			
			clickTab(index){
				if(index > 0){
					Message({
						message: '敬请期待',
						type: 'warning'
					})
				}
			},
			
			loadTargetMajorList(){
				getTargetMajorList({
					'codes': this.codes,
					'group_id': this.groupId
				}).then(res => {
					let realData = res.data;
					this.majorList = realData.majorList;
				});
			},
			
			changeMajor(value) {
				console.log('changeMjor value', value, this.targetMajor);
				let codes = this.targetMajor
				
				if(isEmpty(codes)){
					codes = this.codes;
				}
				
				this.queryParams.page = 1;
												
				this.loadMajorInfoData(codes, true)
			},

			clickIndustry() {
				Message({
					message: '敬请期待',
					type: 'success'
				})
			},
		
			clickCloseGroupDialog(){
				this.showGroupMajorDialog = false;
				this.onGroupDialogClosed();
			},
			
			onGroupDialogClosed(){
				this.targetMajor = '';
				this.loadMajorInfoData(this.codes);
				this.loadTargetMajorList();
			},

			spanMethod({
				row,
				column,
				rowIndex
			}) {
				const colProp = column.property // 当前列字段名
				if (this.majorSpanMap[colProp]) {
					const rowspan = this.majorSpanMap[colProp][rowIndex]
					return {
						rowspan,
						colspan: rowspan === 0 ? 0 : 1
					}
				}
				return {
					rowspan: 1,
					colspan: 1
				}
			},

			clickRoute(item) {
				console.log('item', item)
				let data = parse(item.url)

				if (data) {
					if (data['head'] == 'replace') {
						let url = "/" + data['path'];
						if (data['data'] != null && data['data'].length != 0) {
							url += "?" + data['data'];
						}
						console.log('url', url)
						// this.$router.replace(url);
						this.$router.push(url);
					} else {
						handleRouteProtocal(data)
					}
				}
			},
			
			clickEditGroupMajor() {
				this.showGroupMajorDialog = true;
				this.groupDataList = [];
				this.topMajor = '';
				this.parentMajor = '';
				this.major = '';
				this.dialogParentMajorList = []
				this.dialogMajorList = [];
				this.groupQueryParams.page = 1;
				this.groupAddIndex = 0;
				this.loadGroupTopMajorList();
				this.queryGroupMajorData();
			},
			
			clickAddGroupMajor(code){
				let codeList = this.codes.split(',');
				codeList.push(code)
				this.codes = codeList.join(',')
				this.queryGroupMajorData();
			},
			
			clickRemoveGroupMajor(code){
				let codeList = this.codes.split(',');
				codeList = codeList.filter(item => item != code)
				this.codes = codeList.join(',')
				this.queryGroupMajorData();
			},
			
			queryGroupMajorData() {
				this.groupQueryParams.cur_codes = this.codes;
				this.groupQueryParams.top_code = this.topMajor;
				this.groupQueryParams.parent_code = this.parentMajor;
				this.groupQueryParams.code = this.major;
				this.groupQueryParams.isAdd = this.groupAddList[this.groupAddIndex]['value'];
				getGroupEditMajorList(this.groupQueryParams).then(res => {
					this.groupDataList = res.data.list;
					this.groupQueryParams.total = res.data.pageData.totalCount;
				});
			},
			
			clickSaveMajor() {
				confirmCreateMajorGroup({
					'codes': this.codes,
					'group_id': this.groupId
				}).then(res => {
					this.loadMajorInfoData(this.codes);
				});
			},
			
			loadGroupTopMajorList(query) {
				getGroupTopMajorList({
					name: query
				}).then(res => {
					this.dialogTopMajorList = res.data.topMajorList;
				});
			},

			loadGroupParentMajorList(query) {
				getGroupParentMajorList({
					name: query,
					top_code: this.topMajor
				}).then(res => {
					this.dialogParentMajorList = res.data.parentMajorList;
					this.parentMajor = ''
					console.log('clear major--------')
				});
			},
			
			loadGroupMajorList(query) {
				console.log('loadMajorList query', query)
				getGroupMajorList({
					name: query,
					top_code: this.topMajor,
					parent_code: this.parentMajor
				}).then(res => {
					this.dialogMajorList = res.data.majorList;
					this.major = ''
				});
			},
			
			changeGroupTopMjor(value) {
				this.loadGroupParentMajorList('');
				this.dialogMajorList = []
				this.major = ''
				this.groupQueryParams.page = 1;
				this.queryGroupMajorData();
			},
					
			changeGroupParentMajor(value) {
				this.groupQueryParams.page = 1;
				this.loadGroupMajorList('');
				this.queryGroupMajorData();
			},
					
			changeGroupMajor(value) {
				this.groupQueryParams.page = 1;
				this.queryGroupMajorData();
			},
			
			clickAddTab(index) {
				this.topMajor = '';
				this.parentMajor = '';
				this.major = '';
				this.dialogParentMajorList = []
				this.dialogMajorList = [];
				this.groupQueryParams.page = 1;
				this.groupAddIndex = index;
				this.queryGroupMajorData();
			},
		}
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	@use "major_analyze.scss";
</style>